import { PrescriptionSummary } from "@/domain/entity/prescription/prescription-info-entity";
import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPrescriptionListUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(patientUuid: string): Promise<SATResult<PrescriptionSummary[], SATError>> {
    return this.prescriptionRepo.fetchPrescriptionList(patientUuid);
  }
}
